
<template>
  <!--位置管理-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="position_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-tooltip placement="topLeft" :title="row.category_full_name">
          <span :style="{cursor: 'pointer'}">{{row.category_name}}</span>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'location',
  data () {
    return {
      cascadeParam: {},
      searchList: [
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select', handle: ($event) => this.communityChange(7, $event) },
        { props: ['keywords'], placeholder: '名称', options: [], inputType: 'input' },
        { props: ['category_id'], placeholder: '分类', options: [], inputType: 'cascader', fieldNames: {label: 'title', value: 'category_id', children: 'children'} },
        { props: ['is_strictly'], placeholder: '是否受限', options: this.$store.state.booleanList, inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        { props: ['areas'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业公司', options: [], inputType: 'select' },
        { props: ['building_id'], placeholder: '楼栋', options: [], inputType: 'select', handle: ($event) => this.buildingChange(8, $event) },
        { props: ['unit_id'], placeholder: '单元', options: [], inputType: 'select' }
      ],
      searchParams: {
        community_id: '',
        keywords: '',
        category_id: '',
        is_strictly: '',
        create_date: '',
        areas: '',
        property_id: '',
        building_id: '',
        unit_id: ''
      },
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' },
        { text: '删除', icon: 'close', disabled: true, key: 'batchDel' }
      ],
      rowOptList: [
        { text: '修改', handle: (row) => this.$children[0].toEdit(row, ['can_delete']), key: 'edit' },
        { text: '删除', handle: (row) => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'position_id', align: 'left', width: '' },
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '位置', dataIndex: 'address', align: 'left', width: '' },
        { title: '名称', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '所属分类', dataIndex: 'category_name', align: 'left', width: '', scopedSlots: {customRender: 'action_o'} },
        { title: '是否受限', dataIndex: 'strict_desc', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/position',
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addLocation',
        title: '修改位置'
      },
      deleteParam: {
        url: '/position',
        param: { pk_key: 'position_id', pk_val: '' },
        title: '位置',
        key: 'address'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      this.regionSelect(5);
      this.propertySelect(6);
      this.deviceManageSelect([{ index: 2, scope: 'searchList', key: 'category' }], {category_module: 'position'});
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/location/location.vue